import { Component, output, input } from '@angular/core';

import { trackByValue } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { ThemeName } from '@core/theme-util';
import type { IconName } from '@core/user-interface-legacy';
import {
  DropdownHeaderComponent,
  DropdownItemComponent,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-theme-select-template',
  templateUrl: './theme-select-template.component.html',
  imports: [
    DropdownHeaderComponent,
    IconButtonComponent,
    DropdownItemComponent,
    TranslatePipe,
    IconComponent,
  ],
})
export class ThemeSelectTemplateComponent {
  public readonly selectedTheme = input<ThemeName>(undefined!);
  public readonly themeIconRecord = input<Record<ThemeName, IconName>>(undefined!);
  public readonly themeNameRecord = input<Record<ThemeName, string>>(undefined!);

  public themeChanged = output<ThemeName>();
  public backButtonClick = output<MouseEvent>();

  public themeItems: ThemeName[];

  public trackByValue = trackByValue;

  public ngOnInit() {
    this.themeItems = <ThemeName[]>Object.keys(this.themeNameRecord());
  }

  public onThemeItemCLick(themeName: ThemeName) {
    this.themeChanged.emit(themeName);
  }
}
